module.exports = __webpack_public_path__ + "static/listings_cover.dcb0bdc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/listings_cover.jpg
// module id = 3155
// module chunks = 14018417377433